import { Grid } from '@mui/material';
import { dateFormatLongDate } from '@nx-smartmonkey/shared/helpers';
import { HSpacer, RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import styled from 'styled-components';

import RoutalLogoWhite from '../../../assets/img/routal-logo-white.svg';
import DangerIcon from '../../../assets/img/subscription/danger.svg';
import LicenseHeader from '../../../assets/img/subscription/license-header.png';
import TrafficIcon from '../../../assets/img/subscription/traffic.svg';
import VehiclesIcon from '../../../assets/svg/subscription/VehicleIcon';
import { HeaderContent } from '../../../components/HeaderContent';
import { SMARTMONKEY_TO_ROUTAL_SHORT_NAMES } from '../../../constants/Subscriptions';
import { useRetrieveOrganization } from '../../../hooks/organization/useRetrieveOrganization';
import useCreatePortalSession from '../../../hooks/subscription/useCreatePortalSession';
import Button from '../../../react-components/Button';
import Text from '../../../react-components/Text';
import { intercom } from '../../../services/intercom';

const BillingSubscriptionDataHeaderContainer = styled.div`
  max-height: 117px;
  background-color: transparent;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
`;

const BillingSubscriptionCard = styled.div`
  width: 600px;
  min-height: 500px;
`;

const BillingSubscriptionCardFooter = styled.div`
  width: 600px;
`;

export const BillingSubscriptionData = () => {
  const { data: portalUrl } = useCreatePortalSession();
  const { data: organization } = useRetrieveOrganization();

  if (!organization) {
    return null;
  }

  return (
    <Grid
      container
      direction="column"
      wrap="nowrap"
      style={{ backgroundColor: `white`, zIndex: 2, height: `100%`, overflowY: `auto` }}
    >
      <BillingSubscriptionDataHeaderContainer style={{ display: `relative`, padding: `16px 22px` }}>
        <HeaderContent
          titleIntlId={`settings.billing.subscriptions.title`}
          article={{
            intlId: `settings.billing.subscriptions.claim`,
            onClick: () => {
              intercom.open();
            },
          }}
          styles={{
            container: {
              backgroundColor: `transparent`,
            },
          }}
        />

        <Grid container direction="row" justifyContent="flex-end" alignItems="center">
          <Button
            intlId="settings.billing.subscriptions.administrate"
            onClick={() => {
              window.open(portalUrl, `_blank`);
            }}
          />
        </Grid>
      </BillingSubscriptionDataHeaderContainer>

      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        wrap="nowrap"
        style={{ height: `100%`, width: `100%` }}
      >
        <BillingSubscriptionCard>
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            style={{
              padding: `32px 0`,
              borderTopLeftRadius: `18px`,
              borderTopRightRadius: `18px`,
              background: `url(${LicenseHeader}) no-repeat center center`,
              backgroundSize: `cover`,
            }}
          >
            <Grid item>
              <img src={RoutalLogoWhite} alt="" draggable="false" />
            </Grid>
            <Text variant="h5" style={{ color: RoutalPalette.neutral00 }}>
              {SMARTMONKEY_TO_ROUTAL_SHORT_NAMES[organization.subscription.plan]}
            </Text>
          </Grid>

          <Grid
            item
            container
            wrap="nowrap"
            direction="column"
            justifyContent="center"
            alignItems="center"
            style={{
              padding: `60px`,
              border: `1px solid ${RoutalPalette.primary60}`,
              borderTop: `none`,
              borderBottomLeftRadius: `20px`,
              borderBottomRightRadius: `20px`,
            }}
          >
            <Grid
              item
              container
              wrap="nowrap"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              style={{
                padding: `12px`,
                paddingLeft: `9px`,
                borderBottom: `1px solid ${RoutalPalette.primary80}`,
              }}
            >
              <Grid item container direction="row" wrap="nowrap">
                <VehiclesIcon style={{ height: `24px`, color: RoutalPalette.primary80 }} />
                <HSpacer small />

                <Text
                  variant="body-large"
                  style={{ color: RoutalPalette.primary80 }}
                  intlId="settings.billing.subscriptions.vehicles"
                />
              </Grid>

              <Text variant="body-large" style={{ color: RoutalPalette.primary80 }}>
                {organization.subscription.vehicles}
              </Text>
            </Grid>

            <VSpacer small />

            <Grid
              item
              container
              wrap="nowrap"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              style={{
                padding: `12px`,
                borderBottom: `1px solid ${RoutalPalette.primary80}`,
              }}
            >
              <Grid item container direction="row" wrap="nowrap">
                <img width="18" src={TrafficIcon} alt="" draggable="false" />

                <HSpacer small />

                <Text
                  variant="body-large"
                  style={{ color: RoutalPalette.primary80 }}
                  intlId="settings.billing.subscriptions.traffic"
                />
              </Grid>

              <Text
                variant="body-large"
                style={{ color: RoutalPalette.primary80 }}
                intlId={organization.subscription.traffic ? `enabled` : `disabled`}
              />
            </Grid>

            <VSpacer small />

            {organization.subscription.plan !== `monkey` ? (
              <>
                <Grid
                  item
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  style={{
                    padding: `12px`,
                  }}
                >
                  <Text
                    variant="body-large"
                    style={{ color: RoutalPalette.primary80 }}
                    intlId="settings.billing.subscriptions.sms_credit"
                  />

                  <Text variant="body-large" style={{ color: RoutalPalette.primary80 }}>
                    {organization.subscription.sms.credit}
                  </Text>
                </Grid>

                <VSpacer small />

                <Grid
                  item
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  style={{
                    padding: `12px`,
                  }}
                >
                  <Text
                    variant="body-large"
                    style={{ color: RoutalPalette.primary80 }}
                    intlId="settings.billing.subscriptions.supervisors"
                  />

                  <Text variant="body-large" style={{ color: RoutalPalette.primary80 }}>
                    {organization.subscription.supervisors}
                  </Text>
                </Grid>

                <VSpacer small />

                <Grid
                  item
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  style={{
                    padding: `12px`,
                  }}
                >
                  <Text
                    variant="body-large"
                    style={{ color: RoutalPalette.primary80 }}
                    intlId="settings.billing.subscriptions.projects"
                  />

                  <Text variant="body-large" style={{ color: RoutalPalette.primary80 }}>
                    {organization.subscription.projects}
                  </Text>
                </Grid>

                <VSpacer small />

                <Grid
                  item
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  style={{
                    padding: `12px`,
                  }}
                >
                  <Text
                    variant="body-large"
                    style={{ color: RoutalPalette.primary80 }}
                    intlId="settings.billing.subscriptions.users"
                  />

                  <Text variant="body-large" style={{ color: RoutalPalette.primary80 }}>
                    {organization.subscription.users}
                  </Text>
                </Grid>
              </>
            ) : null}
          </Grid>
        </BillingSubscriptionCard>

        <VSpacer medium />

        <BillingSubscriptionCardFooter>
          <Grid item container direction="row" justifyContent="flex-end" alignItems="center">
            {!organization.subscription.will_cancel ? (
              <>
                {organization.subscription.status === `active` ? (
                  <Text
                    variant="body-medium"
                    style={{ color: RoutalPalette.primary80 }}
                    intlId="settings.billing.subscriptions.scheduled_update"
                    intlValues={{ date: dateFormatLongDate(organization.subscription.current_period_end) }}
                  />
                ) : null}
                {organization.subscription.status === `canceled` ? (
                  <Grid item container direction="row" justifyContent="flex-end" alignItems="center">
                    <img width="24" src={DangerIcon} alt="" draggable="false" />

                    <HSpacer small />

                    <Text
                      variant="body-medium"
                      style={{ color: RoutalPalette.danger }}
                      intlId="settings.billing.subscriptions.canceled"
                    />
                  </Grid>
                ) : null}
              </>
            ) : (
              <Grid item container direction="row" justifyContent="flex-end" alignItems="center">
                {/* This part is not needed but for some reason, when a subscription has been canceled will_cancel is still true. (start) */}
                {organization.subscription.status === `canceled` ? (
                  <Grid item container direction="row" justifyContent="flex-end" alignItems="center">
                    <img width="24" src={DangerIcon} alt="" draggable="false" />

                    <HSpacer small />

                    <Text
                      variant="body-medium"
                      style={{ color: RoutalPalette.danger }}
                      intlId="settings.billing.subscriptions.canceled"
                    />
                    {/* This part is not needed but for some reason, when a subscription has been canceled will_cancel is still true. (end) */}
                  </Grid>
                ) : (
                  <Grid item container direction="row" justifyContent="flex-end" alignItems="center">
                    <img width="24" src={DangerIcon} alt="" draggable="false" />

                    <HSpacer small />

                    <Text
                      variant="body-medium"
                      style={{ color: RoutalPalette.danger }}
                      intlId="settings.billing.subscriptions.scheduled_cancel"
                      intlValues={{ date: dateFormatLongDate(organization.subscription.current_period_end) }}
                    />
                  </Grid>
                )}
              </Grid>
            )}
          </Grid>
        </BillingSubscriptionCardFooter>
      </Grid>
    </Grid>
  );
};
